// Featured Product Slider functionality
document.addEventListener('DOMContentLoaded', () => {
  // Find all section instances
  const sections = document.querySelectorAll('.product-slider-section');

  sections.forEach(section => {
    // Get the section ID from the parent shopify-section
    const shopifySection = section.closest('.shopify-section');
    if (!shopifySection) return;

    const sectionId = shopifySection.id.replace('shopify-section-', '');
    const safeId = sectionId.replace(/-/g, '_');

    // Get products data for this specific section
    const productsKey = `sliderProducts_${safeId}`;
    const products = window[productsKey];

    if (!products || products.length === 0) return;

    initSlider(sectionId, products);
  });
});

function initSlider(sectionId, products) {
  // Current product index
  let currentIndex = 0;

  // DOM Elements
  const productImg = document.getElementById(`productImg-${sectionId}`);
  const lifestyleImg = document.getElementById(`lifestyleImg-${sectionId}`);
  const productCategory = document.getElementById(`productCategory-${sectionId}`);
  const productName = document.getElementById(`productName-${sectionId}`);
  const productPrice = document.getElementById(`productPrice-${sectionId}`);
  const shopBtn = document.getElementById(`shopBtn-${sectionId}`);
  const prevBtn = document.getElementById(`prevBtn-${sectionId}`);
  const nextBtn = document.getElementById(`nextBtn-${sectionId}`);

  // Initialize with first product
  if (products.length > 0) {
    updateProduct(0);
  }

  // Update product display
  function updateProduct(index) {
    const product = products[index];

    // Add fade-out effect
    productImg.classList.add('fade-out');
    lifestyleImg.classList.add('fade-out');

    // Wait for fade-out, then update content and fade-in
    setTimeout(() => {
      // Update images
      productImg.src = product.productImage;
      lifestyleImg.src = product.lifestyleImage;

      // Update text content
      productCategory.textContent = product.category;
      productName.textContent = product.name;
      productPrice.textContent = product.price;

      // Update shop button link
      shopBtn.href = product.url;

      // Remove fade-out and add fade-in
      productImg.classList.remove('fade-out');
      lifestyleImg.classList.remove('fade-out');
      productImg.classList.add('fade-in');
      lifestyleImg.classList.add('fade-in');

      // Remove fade-in class after animation
      setTimeout(() => {
        productImg.classList.remove('fade-in');
        lifestyleImg.classList.remove('fade-in');
      }, 300);
    }, 300);
  }

  // Navigate to previous product
  function prevProduct() {
    currentIndex = (currentIndex - 1 + products.length) % products.length;
    updateProduct(currentIndex);
  }

  // Navigate to next product
  function nextProduct() {
    currentIndex = (currentIndex + 1) % products.length;
    updateProduct(currentIndex);
  }

  // Event Listeners
  prevBtn.addEventListener('click', prevProduct);
  nextBtn.addEventListener('click', nextProduct);

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      prevProduct();
    } else if (e.key === 'ArrowRight') {
      nextProduct();
    }
  });

  // Optional: Auto-slide functionality (uncomment if needed)
  /*
  let autoSlideInterval;

  function startAutoSlide() {
    autoSlideInterval = setInterval(nextProduct, 5000); // Change every 5 seconds
  }

  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }

  // Start auto-slide
  startAutoSlide();

  // Pause on hover
  const container = document.querySelector('.product-slider-section');
  container.addEventListener('mouseenter', stopAutoSlide);
  container.addEventListener('mouseleave', startAutoSlide);
  */

  // Preload images for smooth transitions
  function preloadImages() {
    products.forEach(product => {
      const img1 = new Image();
      const img2 = new Image();
      img1.src = product.productImage;
      img2.src = product.lifestyleImage;
    });
  }

  // Initialize
  preloadImages();
}
